import type { LocaleDictionary } from "@/i18n/types";

const nsSideNavJA = {
  global: {
    ariaLabel: "メインメニュー",
    openButtonAriaLabel: "メインメニューを開く",
    closeButtonAriaLabel: "メインメニューを閉じる",
    openLocalButtonAriaLabel: "サブメニューを開く",
  },
  local: {
    ariaLabel: "サブメニュー",
    closeButtonAriaLabel: "サブメニューを閉じる",
  },
  settings: {
    ariaLabel: "設定メニュー",
    closeButtonAriaLabel: "設定メニューを閉じる",
  },
  item: {
    backToOrganization: "組織に戻る",
    versionList: "バージョン一覧",
    versionComparison: "バージョン比較",
    versions: "バージョン",
    sheets: "シート",
    views: "ビュー",
    organizationSetting: "組織設定",
    algorithmVersions: "アルゴリズムバージョン",
    tadSheets: "時間累積データシート",
    frontendAddons: "フロントエンドアドオン",
    connectMasters: "Connectマスタ",
    endpointAddonMasters: "Endpoint Addonマスタ",
    back: "戻る",
  },
  versionSummary: {
    detailLink: "バージョンサマリを詳しく見る",
    preparing: "-データ準備中- 数分後に更新してください",
    empty: "-サマリが存在しません-",
  },
  addonLoadError: "フロントエンドアドオンが読み込まれていません",
  sortError: {
    sheet: "Sheetのソートに失敗しました。",
    view: "Viewのソートに失敗しました。",
  },
} satisfies LocaleDictionary;

export default nsSideNavJA;
